export enum CheckoutProbabilityPredictionRange {
  ZERO_TO_TEN = "0-10",
  TEN_TO_TWENTY = "10-20",
  TWENTY_TO_THIRTY = "20-30",
  THIRTY_TO_FORTY = "30-40",
  FORTY_TO_FIFTY = "40-50",
  FIFTY_TO_SIXTY = "50-60",
  SIXTY_TO_SEVENTY = "60-70",
  SEVENTY_TO_EIGHTY = "70-80",
  EIGHTY_TO_NINETY = "80-90",
  NINETY_TO_ONE_HUNDRED = "90-100",
}
